/**
 * crmStyles.js - the inline style objects shared by the CRM screens.
 *
 * These live here only because four components need the same values; they are
 * deliberately NOT unified with the look-alike constants in AccountForm /
 * ProjectsView / OpportunitiesView, whose paddings differ. Changing one of
 * those to match is a visual-parity task, not a refactor.
 */

export const INPUT = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  fontSize: 11,
  fontFamily: 'Montserrat',
  outline: 'none',
  boxSizing: 'border-box',
};
export const LABEL = { fontSize: 10.5, fontWeight: 700, color: '#666', marginBottom: 4, display: 'block' };
export const BTN_PRIMARY = {
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  padding: '9px 20px',
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
export const BTN_DELETE = {
  background: '#fff',
  color: '#B71C1C',
  border: '1px solid #FFCDD2',
  padding: '5px 10px',
  borderRadius: 6,
  fontSize: 10.5,
  fontWeight: 700,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
export const BTN_CANCEL = {
  background: '#fff',
  color: '#555',
  border: '1px solid #E0E0E0',
  padding: '7px 16px',
  borderRadius: 6,
  fontWeight: 600,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};

/** A refused save, shown in plain English where it happened. */
export const ERROR_LINE = {
  fontSize: 10.5,
  fontWeight: 600,
  color: '#B71C1C',
  background: '#FFEBEE',
  border: '1px solid #FFCDD2',
  borderRadius: 6,
  padding: '6px 10px',
};

/** Small rounded tag (Designation, Status, Primary, Needs review...). */
export const tagStyle = (fg, bg) => ({
  fontSize: 9,
  fontWeight: 800,
  color: fg,
  background: bg || '#F0F0F0',
  borderRadius: 10,
  padding: '2px 9px',
  whiteSpace: 'nowrap',
  fontFamily: 'Montserrat',
  display: 'inline-block',
  lineHeight: 1.5,
});

/** Designation pills (A-01): Lead is still being pursued, Account is tracked but not a lead (10/21/26), Customer has a PO. */
export const DESIGNATION_COLORS = {
  Target: { fg: '#6A1B9A', bg: '#F3E5F5' },
  Lead: { fg: '#1565C0', bg: '#E3F2FD' },
  Account: { fg: '#455A64', bg: '#ECEFF1' },
  Customer: { fg: '#1B5E20', bg: '#E8F5E9' },
};
export const designationTag = (d) => {
  const c = DESIGNATION_COLORS[d] || DESIGNATION_COLORS.Lead;
  return tagStyle(c.fg, c.bg);
};
/** Status pill (A-03) - a light wash of LEAD_STATUS_COLORS[status]. */
export const statusTag = (color) => tagStyle(color || '#555', `${color || '#555555'}1A`);
